import React from "react";
import {StyledHeroTextInside} from './StyledHeroTextInside';

const HeroTextInside = ({img, text}) => {
  return (
    <React.Fragment>
      <StyledHeroTextInside>
        <div className="wrapper-hero">
          <h4 className="md--title">{text}</h4>
          <div className="background-image" style={{backgroundImage: `url(${img})`}}></div>
        </div>
      </StyledHeroTextInside>
    </React.Fragment>
    
  )
}

export default HeroTextInside;